import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/edit-website-controller';
import { Spinner } from 'components/design';
import { WebsiteForm } from '../components/website-form';

export const EditWebsiteRoute = () => {
    const {
        formData,
        companies,
        onChange,
        onSubmit,
        onCancel,
        dataChanged,
        isLoading,
        isEditWebsiteLoading,
        errors,
        isAdmin,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <WebsiteForm
                    formData={formData}
                    companies={companies}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditWebsiteLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                />
            )}
        </OWContainer>
    );
};
